import { render, staticRenderFns } from "./WelcomeList.vue?vue&type=template&id=29872baf"
import script from "./WelcomeList.vue?vue&type=script&lang=js"
export * from "./WelcomeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports